import React, { useState, useEffect } from 'react';
import { fetchFilteredCarbonRetirements } from '../../config/wilder_requests';
import CarbonRetirementsList from './CarbonRetirementsList';
import { useLanguage } from '../../contexts/LanguageContext';
import { getTranslation } from '../../locales';
import {
  RetirementsContainer,
  RetirementsTitle,
  RetirementsSubtitle,
  LoadingSpinner,
  Spinner,
  ErrorMessage
} from './CarbonRetirements.styles';

const CarbonRetirements = () => {
  const { language } = useLanguage();
  const t = getTranslation(language);
  
  const [retirements, setRetirements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCarbonRetirements();
  }, []);

  const fetchCarbonRetirements = async () => {
    try {
      setLoading(true);
      const filteredRetirements = await fetchFilteredCarbonRetirements();
      setRetirements(filteredRetirements);
    } catch (err) {
      console.error('Erro ao buscar retirements:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <RetirementsContainer>
        <LoadingSpinner>
          <Spinner />
        </LoadingSpinner>
      </RetirementsContainer>
    );
  }

  if (error) {
    return (
      <RetirementsContainer>
        <ErrorMessage>
          {t.carbonRetirements.error}: {error}
        </ErrorMessage>
      </RetirementsContainer>
    );
  }

  return (
    <RetirementsContainer>
      <RetirementsTitle>{t.carbonRetirements.title}</RetirementsTitle>
      <RetirementsSubtitle>
        {t.carbonRetirements.subtitle}
      </RetirementsSubtitle>

      <CarbonRetirementsList results={retirements} />
    </RetirementsContainer>
  );
};

export default CarbonRetirements;
